export default __webpack_public_path__ + "533c533e06a509cb80cf7f66be66d042.png";